// https://vuex.vuejs.org/en/state.html

export default {
    token: localStorage.getItem("user-token") || "",
    name: localStorage.getItem("name") || "",
    site: localStorage.getItem("site") || "",
    familyID: localStorage.getItem("familyID") || "",
    status: "",
};
